// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Responsive overrides for src/pages/Developer.jsx.
 * Loaded AFTER index.css so equal-specificity rules here win by source order.
 *
 * Breakpoints (project standard):
 *   mobile  : <=576px
 *   tablet  : 577-991px
 *   laptop  : 992-1280px
 *   desktop : >=1281px
 *
 * DO NOT EDIT src/index.css. All overrides live here.
 */

/* ===========================================================================
 * TABLET (<=991px): minor layout adjustments
 * ======================================================================== */
@media (max-width: 991px) {
  /* Stats: 2-column grid on tablet */
  .developer-page .stats-row {
    grid-template-columns: repeat(2, 1fr);
  }

  /* Tabs: allow horizontal scroll if they overflow on narrow tablets */
  .developer-page .developer-tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    flex-wrap: nowrap;
  }

  .developer-page .developer-tabs::-webkit-scrollbar {
    display: none;
  }

  /* API keys header: allow wrapping */
  .developer-page .api-keys-header {
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  /* Delivery summary: allow the time to wrap */
  .developer-page .delivery-summary {
    flex-wrap: wrap;
  }
}

/* ===========================================================================
 * MOBILE (<=576px): full single-column, app-like layout
 * ======================================================================== */
@media (max-width: 576px) {

  /* ---- Page wrapper ---- */
  .developer-page {
    padding: 0;
  }

  /* ---- Page header ---- */
  .developer-page .page-header h1 {
    font-size: 1.375rem;
  }

  /* ---- Stats row: 2-col grid on mobile (4 stats, 2x2 looks better than 1-col) ---- */
  .developer-page .stats-row {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  .developer-page .stat-card {
    padding: 0.875rem 0.75rem;
    gap: 0.75rem;
  }

  .developer-page .stat-value {
    font-size: 1.25rem;
  }

  /* ---- Developer tabs: horizontal scroll, no wrap ---- */
  .developer-page .developer-tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    flex-wrap: nowrap;
    margin-bottom: 1rem;
    display: inline-block;
    width: 100%;
  }

  .developer-page .developer-tabs::-webkit-scrollbar {
    display: none;
  }

  .developer-page .developer-tabs .tab {
    flex-shrink: 0;
    padding: 0.75rem 1rem;
    min-height: 44px;
    font-size: 0.875rem;
    white-space: nowrap;
    width: 100%;
  }

  /* ---- API Keys section ---- */

  /* Header: stack "Your API Keys" title and button */
  .developer-page .api-keys-header {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    margin-bottom: 0.875rem;
  }

  .developer-page .api-keys-header h3 {
    font-size: 1rem;
  }

  .developer-page .create-key-btn {
    width: 100%;
    justify-content: center;
    min-height: 44px;
    padding: 0.75rem 1rem;
  }

  /* Empty state: comfortable padding */
  .developer-page .empty-state {
    padding: 2.5rem 1rem;
  }

  .developer-page .empty-state .btn-primary {
    width: 100%;
    justify-content: center;
    min-height: 44px;
  }

  /* API key card: reduce padding slightly */
  .developer-page .api-key-card {
    padding: 1rem;
  }

  /* Key header: stack title+badge above actions */
  .developer-page .key-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.625rem;
  }

  .developer-page .key-actions {
    align-self: flex-start;
    gap: 0.375rem;
  }

  /* Ensure action buttons meet tap target */
  .developer-page .key-actions .toggle-btn {
    min-height: 36px;
    padding: 0.375rem 0.75rem;
  }

  .developer-page .key-actions .icon-btn {
    min-width: 36px;
    min-height: 36px;
  }

  /* API key value: allow text overflow ellipsis (already set in inline CSS,
     this ensures the container doesn't cause horizontal scroll) */
  .developer-page .key-value-row {
    min-width: 0;
  }

  .developer-page .key-value-row code {
    min-width: 0;
  }

  /* Key meta: already has flex-wrap:wrap; tighten gap */
  .developer-page .key-meta {
    gap: 0.5rem;
    font-size: 0.8rem;
  }

  /* ---- Documentation section ---- */
  .developer-page .doc-card-body {
    padding: 1rem;
  }

  .developer-page .doc-card-header {
    padding: 0.875rem 1rem;
  }

  /* Language tabs: horizontal scroll */
  .developer-page .language-tabs {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    flex-wrap: nowrap;
    gap: 0.375rem;
    padding-bottom: 2px;
  }

  .developer-page .language-tabs::-webkit-scrollbar {
    display: none;
  }

  .developer-page .language-tabs button {
    flex-shrink: 0;
    min-height: 36px;
    white-space: nowrap;
  }

  /* Code blocks: horizontal scroll INSIDE the block, page never scrolls */
  .developer-page .code-block {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .developer-page .code-block pre {
    /* Use pre (not pre-wrap) so long lines scroll inside the block */
    white-space: pre;
    word-break: normal;
    min-width: max-content;
  }

  /* Keep copy button accessible on small screens */
  .developer-page .copy-code-btn {
    position: static;
    display: flex;
    margin-top: 0.75rem;
    align-self: flex-start;
  }

  /* When code-block.large is used, make the whole block a column flex */
  .developer-page .code-block.large {
    display: flex;
    flex-direction: column;
    max-height: 300px;
  }

  /* Params table: contained horizontal scroll inside its own box */
  .developer-page .params-table {
    display: block;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
  }

  .developer-page .params-table th,
  .developer-page .params-table td {
    white-space: normal;
    min-width: 80px;
  }

  /* Endpoint: allow code to wrap on very narrow screens */
  .developer-page .endpoint {
    flex-wrap: wrap;
  }

  .developer-page .endpoint code {
    font-size: 0.8rem;
    word-break: break-all;
  }

  /* Event items: stack code + description on mobile */
  .developer-page .event-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.375rem;
  }

  .developer-page .event-item code {
    min-width: unset;
  }

  .developer-page .event-item span {
    text-align: left;
  }

  /* Warning box: reduce padding */
  .developer-page .warning-box {
    padding: 0.875rem 1rem;
    gap: 0.75rem;
  }

  /* Use cases grid: single column */
  .developer-page .use-cases-grid {
    grid-template-columns: 1fr;
  }

  /* Steps: tighten gap */
  .developer-page .steps {
    gap: 1.25rem;
  }

  /* Section intro: reduce bottom margin */
  .developer-page .section-intro {
    margin-bottom: 1rem;
  }

  /* ---- Webhooks: delivery log ---- */

  /* Delivery summary row: allow wrapping so time & resend don't clip off-screen */
  .developer-page .delivery-summary {
    flex-wrap: wrap;
    gap: 0.4rem;
    padding: 0.75rem;
    min-height: 44px;
  }

  /* Time: no longer margin-left: auto, just flows with other items */
  .developer-page .delivery-time {
    margin-left: 0;
    width: 100%;
    font-size: 0.7rem;
  }

  .developer-page .delivery-resend {
    margin-left: auto;
  }

  /* Delivery detail: reduce padding */
  .developer-page .delivery-detail {
    padding: 0.75rem;
  }

  /* Delivery meta URLs wrap */
  .developer-page .delivery-meta {
    word-break: break-all;
  }

  /* ---- Modals -> bottom sheets ---- */

  /* Overlay: remove centering padding so sheet can touch edges */
  .developer-page ~ .modal-overlay,
  .developer-page + .modal-overlay {
    padding: 0;
    align-items: flex-end;
  }

  /* Use a data attribute placed on the overlay via JSX for scoping;
     since the overlays are inside .developer-page's returned JSX tree,
     we target them via the overlay class directly when inside the page's DOM
     context. The overlays are siblings to content in the same root div, so
     we use the developer-page parent selector approach. */

  /* Modal base: full-width bottom sheet */
  .developer-page .modal-overlay {
    padding: 0;
    align-items: flex-end;
  }

  .developer-page .modal,
  .developer-page .modal-sm {
    max-width: 90%;
    width: 100%;
    border-radius: 16px 16px 0 0;
    max-height: 92vh;
    animation: devModalSlideUp 0.28s cubic-bezier(0.32, 0.72, 0, 1);
    padding-bottom: env(safe-area-inset-bottom, 0px);
    /* position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%; */
    margin: 0 auto;
    position: relative;
    top: -30px;
  }

  @keyframes devModalSlideUp {
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
  }

  /* Modal footer: stack buttons vertically, full-width */
  .developer-page .modal-footer {
    flex-direction: column-reverse;
    align-items: stretch;
    gap: 0.625rem;
    padding: 1rem 1rem calc(1rem + env(safe-area-inset-bottom, 0px));
  }

  .developer-page .modal-footer .btn-primary,
  .developer-page .modal-footer .btn-secondary,
  .developer-page .modal-footer .btn-danger {
    width: 100%;
    justify-content: center;
    min-height: 48px;
  }

  /* Form: full-width inputs */
  .developer-page .form-group input,
  .developer-page .form-group textarea,
  .developer-page .form-group select {
    width: 100%;
    min-height: 44px;
    box-sizing: border-box;
  }

  /* Form-row: single column */
  .developer-page .form-row {
    grid-template-columns: 1fr;
  }

  /* Close button: adequate tap target */
  .developer-page .close-btn {
    min-width: 44px;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* Refresh button in delivery log header: adequate touch target */
  .developer-page .btn-secondary.small {
    min-height: 36px;
    min-width: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/responsive/pages/Developer.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;EAWE;;AAEF;;6EAE6E;AAC7E;EACE,mCAAmC;EACnC;IACE,qCAAqC;EACvC;;EAEA,qEAAqE;EACrE;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA,oCAAoC;EACpC;IACE,eAAe;IACf,YAAY;EACd;;EAEA,6CAA6C;EAC7C;IACE,eAAe;EACjB;AACF;;AAEA;;6EAE6E;AAC7E;;EAEE,2BAA2B;EAC3B;IACE,UAAU;EACZ;;EAEA,0BAA0B;EAC1B;IACE,mBAAmB;EACrB;;EAEA,qFAAqF;EACrF;IACE,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA,yDAAyD;EACzD;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;EACb;;EAEA,+BAA+B;;EAE/B,mDAAmD;EACnD;IACE,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA,qCAAqC;EACrC;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,0CAA0C;EAC1C;IACE,aAAa;EACf;;EAEA,gDAAgD;EAChD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA,0CAA0C;EAC1C;IACE,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;kEACgE;EAChE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA,sDAAsD;EACtD;IACE,WAAW;IACX,iBAAiB;EACnB;;EAEA,oCAAoC;EACpC;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA,qCAAqC;EACrC;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA,wEAAwE;EACxE;IACE,gBAAgB;IAChB,iCAAiC;EACnC;;EAEA;IACE,iEAAiE;IACjE,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA,iDAAiD;EACjD;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA,sEAAsE;EACtE;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA,iEAAiE;EACjE;IACE,cAAc;IACd,gBAAgB;IAChB,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;IACnB,eAAe;EACjB;;EAEA,wDAAwD;EACxD;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA,oDAAoD;EACpD;IACE,sBAAsB;IACtB,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA,gCAAgC;EAChC;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA,kCAAkC;EAClC;IACE,0BAA0B;EAC5B;;EAEA,uBAAuB;EACvB;IACE,YAAY;EACd;;EAEA,wCAAwC;EACxC;IACE,mBAAmB;EACrB;;EAEA,qCAAqC;;EAErC,gFAAgF;EAChF;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA,mEAAmE;EACnE;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA,oCAAoC;EACpC;IACE,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;IACE,qBAAqB;EACvB;;EAEA,sCAAsC;;EAEtC,+DAA+D;EAC/D;;IAEE,UAAU;IACV,qBAAqB;EACvB;;EAEA;;;;0DAIwD;;EAExD,wCAAwC;EACxC;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;;IAEE,cAAc;IACd,WAAW;IACX,4BAA4B;IAC5B,gBAAgB;IAChB,+DAA+D;IAC/D,gDAAgD;IAChD;;;gBAGY;IACZ,cAAc;IACd,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,OAAO,2BAA2B,EAAE;IACpC,OAAO,wBAAwB,EAAE;EACnC;;EAEA,uDAAuD;EACvD;IACE,8BAA8B;IAC9B,oBAAoB;IACpB,aAAa;IACb,gEAAgE;EAClE;;EAEA;;;IAGE,WAAW;IACX,uBAAuB;IACvB,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;;;IAGE,WAAW;IACX,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA,4BAA4B;EAC5B;IACE,0BAA0B;EAC5B;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,iEAAiE;EACjE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF","sourcesContent":["/*\n * Responsive overrides for src/pages/Developer.jsx.\n * Loaded AFTER index.css so equal-specificity rules here win by source order.\n *\n * Breakpoints (project standard):\n *   mobile  : <=576px\n *   tablet  : 577-991px\n *   laptop  : 992-1280px\n *   desktop : >=1281px\n *\n * DO NOT EDIT src/index.css. All overrides live here.\n */\n\n/* ===========================================================================\n * TABLET (<=991px): minor layout adjustments\n * ======================================================================== */\n@media (max-width: 991px) {\n  /* Stats: 2-column grid on tablet */\n  .developer-page .stats-row {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  /* Tabs: allow horizontal scroll if they overflow on narrow tablets */\n  .developer-page .developer-tabs {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    flex-wrap: nowrap;\n  }\n\n  .developer-page .developer-tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* API keys header: allow wrapping */\n  .developer-page .api-keys-header {\n    flex-wrap: wrap;\n    gap: 0.75rem;\n  }\n\n  /* Delivery summary: allow the time to wrap */\n  .developer-page .delivery-summary {\n    flex-wrap: wrap;\n  }\n}\n\n/* ===========================================================================\n * MOBILE (<=576px): full single-column, app-like layout\n * ======================================================================== */\n@media (max-width: 576px) {\n\n  /* ---- Page wrapper ---- */\n  .developer-page {\n    padding: 0;\n  }\n\n  /* ---- Page header ---- */\n  .developer-page .page-header h1 {\n    font-size: 1.375rem;\n  }\n\n  /* ---- Stats row: 2-col grid on mobile (4 stats, 2x2 looks better than 1-col) ---- */\n  .developer-page .stats-row {\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.75rem;\n    margin-bottom: 1rem;\n  }\n\n  .developer-page .stat-card {\n    padding: 0.875rem 0.75rem;\n    gap: 0.75rem;\n  }\n\n  .developer-page .stat-value {\n    font-size: 1.25rem;\n  }\n\n  /* ---- Developer tabs: horizontal scroll, no wrap ---- */\n  .developer-page .developer-tabs {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    flex-wrap: nowrap;\n    margin-bottom: 1rem;\n    display: inline-block;\n    width: 100%;\n  }\n\n  .developer-page .developer-tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .developer-page .developer-tabs .tab {\n    flex-shrink: 0;\n    padding: 0.75rem 1rem;\n    min-height: 44px;\n    font-size: 0.875rem;\n    white-space: nowrap;\n    width: 100%;\n  }\n\n  /* ---- API Keys section ---- */\n\n  /* Header: stack \"Your API Keys\" title and button */\n  .developer-page .api-keys-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n    margin-bottom: 0.875rem;\n  }\n\n  .developer-page .api-keys-header h3 {\n    font-size: 1rem;\n  }\n\n  .developer-page .create-key-btn {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n    padding: 0.75rem 1rem;\n  }\n\n  /* Empty state: comfortable padding */\n  .developer-page .empty-state {\n    padding: 2.5rem 1rem;\n  }\n\n  .developer-page .empty-state .btn-primary {\n    width: 100%;\n    justify-content: center;\n    min-height: 44px;\n  }\n\n  /* API key card: reduce padding slightly */\n  .developer-page .api-key-card {\n    padding: 1rem;\n  }\n\n  /* Key header: stack title+badge above actions */\n  .developer-page .key-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.625rem;\n  }\n\n  .developer-page .key-actions {\n    align-self: flex-start;\n    gap: 0.375rem;\n  }\n\n  /* Ensure action buttons meet tap target */\n  .developer-page .key-actions .toggle-btn {\n    min-height: 36px;\n    padding: 0.375rem 0.75rem;\n  }\n\n  .developer-page .key-actions .icon-btn {\n    min-width: 36px;\n    min-height: 36px;\n  }\n\n  /* API key value: allow text overflow ellipsis (already set in inline CSS,\n     this ensures the container doesn't cause horizontal scroll) */\n  .developer-page .key-value-row {\n    min-width: 0;\n  }\n\n  .developer-page .key-value-row code {\n    min-width: 0;\n  }\n\n  /* Key meta: already has flex-wrap:wrap; tighten gap */\n  .developer-page .key-meta {\n    gap: 0.5rem;\n    font-size: 0.8rem;\n  }\n\n  /* ---- Documentation section ---- */\n  .developer-page .doc-card-body {\n    padding: 1rem;\n  }\n\n  .developer-page .doc-card-header {\n    padding: 0.875rem 1rem;\n  }\n\n  /* Language tabs: horizontal scroll */\n  .developer-page .language-tabs {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    flex-wrap: nowrap;\n    gap: 0.375rem;\n    padding-bottom: 2px;\n  }\n\n  .developer-page .language-tabs::-webkit-scrollbar {\n    display: none;\n  }\n\n  .developer-page .language-tabs button {\n    flex-shrink: 0;\n    min-height: 36px;\n    white-space: nowrap;\n  }\n\n  /* Code blocks: horizontal scroll INSIDE the block, page never scrolls */\n  .developer-page .code-block {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .developer-page .code-block pre {\n    /* Use pre (not pre-wrap) so long lines scroll inside the block */\n    white-space: pre;\n    word-break: normal;\n    min-width: max-content;\n  }\n\n  /* Keep copy button accessible on small screens */\n  .developer-page .copy-code-btn {\n    position: static;\n    display: flex;\n    margin-top: 0.75rem;\n    align-self: flex-start;\n  }\n\n  /* When code-block.large is used, make the whole block a column flex */\n  .developer-page .code-block.large {\n    display: flex;\n    flex-direction: column;\n    max-height: 300px;\n  }\n\n  /* Params table: contained horizontal scroll inside its own box */\n  .developer-page .params-table {\n    display: block;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    white-space: nowrap;\n  }\n\n  .developer-page .params-table th,\n  .developer-page .params-table td {\n    white-space: normal;\n    min-width: 80px;\n  }\n\n  /* Endpoint: allow code to wrap on very narrow screens */\n  .developer-page .endpoint {\n    flex-wrap: wrap;\n  }\n\n  .developer-page .endpoint code {\n    font-size: 0.8rem;\n    word-break: break-all;\n  }\n\n  /* Event items: stack code + description on mobile */\n  .developer-page .event-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 0.375rem;\n  }\n\n  .developer-page .event-item code {\n    min-width: unset;\n  }\n\n  .developer-page .event-item span {\n    text-align: left;\n  }\n\n  /* Warning box: reduce padding */\n  .developer-page .warning-box {\n    padding: 0.875rem 1rem;\n    gap: 0.75rem;\n  }\n\n  /* Use cases grid: single column */\n  .developer-page .use-cases-grid {\n    grid-template-columns: 1fr;\n  }\n\n  /* Steps: tighten gap */\n  .developer-page .steps {\n    gap: 1.25rem;\n  }\n\n  /* Section intro: reduce bottom margin */\n  .developer-page .section-intro {\n    margin-bottom: 1rem;\n  }\n\n  /* ---- Webhooks: delivery log ---- */\n\n  /* Delivery summary row: allow wrapping so time & resend don't clip off-screen */\n  .developer-page .delivery-summary {\n    flex-wrap: wrap;\n    gap: 0.4rem;\n    padding: 0.75rem;\n    min-height: 44px;\n  }\n\n  /* Time: no longer margin-left: auto, just flows with other items */\n  .developer-page .delivery-time {\n    margin-left: 0;\n    width: 100%;\n    font-size: 0.7rem;\n  }\n\n  .developer-page .delivery-resend {\n    margin-left: auto;\n  }\n\n  /* Delivery detail: reduce padding */\n  .developer-page .delivery-detail {\n    padding: 0.75rem;\n  }\n\n  /* Delivery meta URLs wrap */\n  .developer-page .delivery-meta {\n    word-break: break-all;\n  }\n\n  /* ---- Modals -> bottom sheets ---- */\n\n  /* Overlay: remove centering padding so sheet can touch edges */\n  .developer-page ~ .modal-overlay,\n  .developer-page + .modal-overlay {\n    padding: 0;\n    align-items: flex-end;\n  }\n\n  /* Use a data attribute placed on the overlay via JSX for scoping;\n     since the overlays are inside .developer-page's returned JSX tree,\n     we target them via the overlay class directly when inside the page's DOM\n     context. The overlays are siblings to content in the same root div, so\n     we use the developer-page parent selector approach. */\n\n  /* Modal base: full-width bottom sheet */\n  .developer-page .modal-overlay {\n    padding: 0;\n    align-items: flex-end;\n  }\n\n  .developer-page .modal,\n  .developer-page .modal-sm {\n    max-width: 90%;\n    width: 100%;\n    border-radius: 16px 16px 0 0;\n    max-height: 92vh;\n    animation: devModalSlideUp 0.28s cubic-bezier(0.32, 0.72, 0, 1);\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n    /* position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    left: 50%; */\n    margin: 0 auto;\n    position: relative;\n    top: -30px;\n  }\n\n  @keyframes devModalSlideUp {\n    from { transform: translateY(100%); }\n    to   { transform: translateY(0); }\n  }\n\n  /* Modal footer: stack buttons vertically, full-width */\n  .developer-page .modal-footer {\n    flex-direction: column-reverse;\n    align-items: stretch;\n    gap: 0.625rem;\n    padding: 1rem 1rem calc(1rem + env(safe-area-inset-bottom, 0px));\n  }\n\n  .developer-page .modal-footer .btn-primary,\n  .developer-page .modal-footer .btn-secondary,\n  .developer-page .modal-footer .btn-danger {\n    width: 100%;\n    justify-content: center;\n    min-height: 48px;\n  }\n\n  /* Form: full-width inputs */\n  .developer-page .form-group input,\n  .developer-page .form-group textarea,\n  .developer-page .form-group select {\n    width: 100%;\n    min-height: 44px;\n    box-sizing: border-box;\n  }\n\n  /* Form-row: single column */\n  .developer-page .form-row {\n    grid-template-columns: 1fr;\n  }\n\n  /* Close button: adequate tap target */\n  .developer-page .close-btn {\n    min-width: 44px;\n    min-height: 44px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  /* Refresh button in delivery log header: adequate touch target */\n  .developer-page .btn-secondary.small {\n    min-height: 36px;\n    min-width: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
